import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Utils
import { pushDetalizationAnalytics } from 'utils/analytics/detalization';

// Components
import { RouterLink, Menu, Link } from 'components';
import { ANALYTICS_DETAIL } from 'constants/detalization';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Navigation = ({
  links,
  activeLink,
  history,
  nameId,
}) => {
  useEffect(() => {
    if (activeLink.path === '/detalization') {
      pushDetalizationAnalytics(ANALYTICS_DETAIL.CLICK_ON_NAVIGATION, { screen: 'lk' });
    }
  }, [activeLink]);

  return (
    <div
      id={nameId}
    >
      <nav className={cx('desktop')}>
        {links.map((link) => (
          <div
            className={cx('link')}
            key={`nav-link-${link.page}`}
          >
            {link.newPage ? (
              <Link href={link.path}>
                {link.title}
              </Link>
            ) : (
              <RouterLink
                className="link--hidden-visited-color"
                to={link.path}
              >
                {link.title}
              </RouterLink>
            )}
            {link.badge && (
              <span className={cx('badge')}>{link.badge}</span>
            )}
          </div>
        ))}
      </nav>
      <Menu
        className={cx('mobile')}
        entries={links}
        labelProperty="title"
        idProperty="page"
        activeEntry={links.findIndex((l) => l.path === activeLink.path)}
        onEntryClick={({ path }) => history.push(path)}
      />
    </div>
  );
};

Navigation.propTypes = {
  links: PropTypes.array,
  activeLink: PropTypes.object,
  history: PropTypes.object,
  nameId: PropTypes.string,
};

export default Navigation;
